export default __webpack_public_path__ + "static/media/service.bd5fe616.svg";